import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDataTable, {
    staticClass: "datatable-supplier overflow-unset",
    attrs: {
      "item-key": "id",
      headers: _vm.headers,
      items: _vm.suppliers,
      "items-per-page": -1,
      loading: _vm.datatableLoading,
      "loading-text": "It may take a few moment, please wait...",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.supplier",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "supplier-title",
          class: {
            "text-error": item.isNoSupplierPrice
          }
        }, [!item.isNoSupplierPrice ? _c(VIcon, {
          staticClass: "fas fa-arrow-alt-circle-down mr-2",
          class: _vm.getSupplierStatus(item),
          attrs: {
            small: ""
          }
        }) : _vm._e(), _c("span", [_vm._v(" " + _vm._s(item.name) + " ")])], 1)];
      }
    }, {
      key: "item.items",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "pa-1"
        }, [_c(VExpansionPanels, {
          staticClass: "expansion-panels",
          model: {
            value: _vm.openedPanels[item.id],
            callback: function callback($$v) {
              _vm.$set(_vm.openedPanels, item.id, $$v);
            },
            expression: "openedPanels[item.id]"
          }
        }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v(" Item" + _vm._s(item.items.length > 1 ? "s" : "") + " (" + _vm._s(item.items.length) + ") ")]), _c(VExpansionPanelContent, [_c("div", {
          staticClass: "panel-content"
        }, _vm._l(item.items, function (supplierItem) {
          return _c("div", {
            key: "".concat(supplierItem.id_item, "_").concat(supplierItem.splitIndex || 0),
            ref: "split-item-".concat(supplierItem.id_item, "-").concat(supplierItem.splitIndex),
            refInFor: true,
            staticClass: "panel-row",
            class: {
              "split-group-highlighted": supplierItem.isSplit && _vm.highlightedSplitGroupId === supplierItem.splitGroupId
            }
          }, [_c("div", {
            staticClass: "item-row-wrapper"
          }, [_c("div", {
            staticClass: "item-status-icon"
          }, [supplierItem.associatedPOs && supplierItem.associatedPOs.length > 0 ? _c(VIcon, {
            staticClass: "fas fa-arrow-alt-circle-down sourcing-icon",
            class: _vm.getGlobalItemStatus(supplierItem),
            attrs: {
              small: ""
            }
          }) : _c(VIcon, {
            staticClass: "fas fa-arrow-alt-circle-down status-icon danger",
            attrs: {
              small: ""
            }
          })], 1), _c("div", {
            staticClass: "item-quantity-badge"
          }, [_c("span", [_vm._v(_vm._s(supplierItem.original_qty) + " b.")]), supplierItem.isSplit ? _c("div", [_c("span", {
            staticClass: "text-smaller"
          }, [_vm._v("Split :")])]) : _vm._e(), supplierItem.isSplit ? _c(VTooltip, {
            attrs: {
              bottom: ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function fn(_ref3) {
                var on = _ref3.on,
                  attrs = _ref3.attrs;
                return [_c("div", _vm._g(_vm._b({
                  staticClass: "ml-2 split-text text-smaller",
                  class: {
                    "split-highlighted": _vm.highlightedSplitGroupId === supplierItem.splitGroupId
                  },
                  on: {
                    click: function click($event) {
                      return _vm.toggleHighlightSplitGroup(supplierItem.splitGroupId, supplierItem);
                    }
                  }
                }, "div", attrs, false), on), _vm._l(_vm.getSplitGroupItems(supplierItem.splitGroupId, supplierItem), function (splitItem, index) {
                  return _c("div", {
                    key: index,
                    staticClass: "split-line",
                    on: {
                      click: function click($event) {
                        $event.stopPropagation();
                        return _vm.scrollToSplitItem(splitItem);
                      }
                    }
                  }, [_c(VIcon, {
                    staticClass: "fas fa-arrow-right",
                    staticStyle: {
                      color: "black"
                    },
                    attrs: {
                      "x-small": ""
                    }
                  }), _vm._v(" " + _vm._s(splitItem.quantity) + " b. " + _vm._s(splitItem.supplierName || "Undefined Supplier ") + " "), splitItem.poReference ? _c("span", [_vm._v(" #" + _vm._s(splitItem.poReference.shorterReference()) + " ")]) : _vm._e()], 1);
                }), 0)];
              }
            }], null, true)
          }, [_c("span", [_vm._v("Click to highlight and scroll to the related split part")])]) : _vm._e()], 1), _c("div", {
            staticClass: "item-wine-details"
          }, [_c("router-link", {
            staticClass: "router-link",
            attrs: {
              to: _vm.goToProductDetails(supplierItem.wine),
              target: "_blank"
            }
          }, [_c("div", {
            staticClass: "wine-name"
          }, [_vm._v(_vm._s(supplierItem.wine.display_name))])]), _c("div", {
            staticClass: "wine-sku"
          }, [_vm._v(_vm._s(supplierItem.wine.sku))]), _c(VBtn, {
            staticClass: "dfwa-btn --small-2 px-1",
            attrs: {
              rounded: true
            },
            on: {
              click: function click($event) {
                return _vm.openSupplierPrices(supplierItem.wine.id_wine);
              }
            }
          }, [_vm._v(" sup.prices ")])], 1), _c("div", {
            staticClass: "item-po-info"
          }, [supplierItem.associatedPOs && supplierItem.associatedPOs.length > 0 ? _c("div", _vm._l(supplierItem.associatedPOs, function (po) {
            return _c("div", {
              key: po.id,
              staticClass: "po-tag"
            }, [_c("span", {
              staticClass: "po-quantity"
            }, [_c(VIcon, {
              class: [_vm.getPoItemStatus(po, supplierItem.quantity), "mr-2"],
              attrs: {
                small: ""
              }
            }), _vm._v(" " + _vm._s(po.quantity) + " b. / " + _vm._s(supplierItem.original_qty) + " b. ")], 1), _c("router-link", {
              attrs: {
                to: _vm.goToPurchaseOrder(po),
                target: "_blank"
              }
            }, [_c("span", {
              staticClass: "po-reference"
            }, [_vm._v("#" + _vm._s(po.number.shorterReference()))])])], 1);
          }), 0) : _c("div", {
            staticClass: "no-po-info"
          }, [_c("span", {
            staticClass: "dispatch-label"
          }, [_c(VIcon, {
            staticClass: "fas fa-times-circle danger",
            attrs: {
              small: ""
            }
          }), _vm._v(" There is no associated purchase order ")], 1)])]), _c("div", {
            staticClass: "item-order-link"
          }, [_c("router-link", {
            attrs: {
              to: _vm.goToOrder(supplierItem.id_order),
              target: "_blank"
            }
          }, [_vm._v(" " + _vm._s(supplierItem.orderType == _vm.orderTypes.CONTAINER ? "#".concat(supplierItem.reference_order.shorterReference()) : "#".concat(supplierItem.reference_order.shorterReference())) + " ")])], 1), supplierItem.bestSupplierPrice ? _c("div", {
            staticClass: "item-best-price"
          }, [_c(VCard, {
            staticClass: "best-price-card elevation-1"
          }, [_c(VCardText, {
            staticClass: "pa-1"
          }, [_c("div", {
            staticClass: "best-price-amount"
          }, [_c("span", {
            staticClass: "price-label"
          }, [_vm._v("Best price:")]), _c("span", {
            staticClass: "price-value"
          }, [_vm._v(" " + _vm._s(_vm.formatPrice(supplierItem.bestSupplierPrice.price)) + "€ ")])])])], 1)], 1) : _vm._e()])]);
        }), 0)])], 1)], 1)], 1)];
      }
    }])
  }), _vm.isWineSupplierPriceModalShown ? _c("WineSupplierPriceModal", {
    ref: "wineSupplierPriceModalRef",
    attrs: {
      wineId: _vm.currentWineId
    },
    on: {
      closed: _vm.closeSupplierPrices
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };